export const OnboardingFlow = {
  DraftMattersCoachMark: 'draft-matters-coach-mark',
  ImportSettingsCoachMark: 'import-settings-coach-mark',
  IntroDialog: 'intro-dialog',
  UploadBreakdownCoachMark: 'upload-breakdown-coach-mark',
  UploadResultCoachMark: 'upload-result-coach-mark',
} as const;

export type OnboardingFlow = (typeof OnboardingFlow)[keyof typeof OnboardingFlow];
